<div class="iq-feature-01">
  <ng-content select="[featureIcon]"></ng-content>
  <ng-content select="[featureBody]"></ng-content>
</div>
